import WmsSettingForm from './WmsSettingForm'
import Header from '../../Components/Header'

const WmsSetting = () => {
    return (
        <>
            <Header />
            <div className="container-fluid maindiv">
                <WmsSettingForm />
            </div>
        </>
    )
}

export default WmsSetting